export const APP_CART_DATA_KEY = 'cart_data';
